export type CollectSnapshot = {
  url: string;
  referrer: string | null;
  ua: string;
  timezone: string | null;
  locale: string | null;
  languages: string[];
  screen: { w: number; h: number; dpr: number; colorDepth: number };
  viewport: { w: number; h: number };
  ts: number;
};

export function readSnapshot(ts = Date.now()): CollectSnapshot {
  const locale = navigator.language ?? null;
  const languages = Array.from(navigator.languages ?? (locale ? [locale] : [])).filter(
    (value): value is string => typeof value === 'string' && value.length > 0,
  );

  return {
    url: location.href,
    referrer: document.referrer || null,
    ua: navigator.userAgent,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? null,
    locale,
    languages,
    screen: {
      w: window.screen.width,
      h: window.screen.height,
      dpr: window.devicePixelRatio,
      colorDepth: window.screen.colorDepth,
    },
    viewport: { w: window.innerWidth, h: window.innerHeight },
    ts,
  };
}

export function snapshotSignature(snapshot: CollectSnapshot, fingerprintHash: string | null): string {
  return JSON.stringify({
    ...snapshot,
    fingerprintHash,
  });
}
